// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contact-js": () => import("/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-gallery-js": () => import("/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/src/pages/gallery.js" /* webpackChunkName: "component---src-pages-gallery-js" */),
  "component---src-pages-index-js": () => import("/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-menu-js": () => import("/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/src/pages/menu.js" /* webpackChunkName: "component---src-pages-menu-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/.cache/data.json")

